<template>
  <div class="chapters-tab" data-testid="chapters-tab">
    <!-- Empty State -->
    <div v-if="!hasChapters" class="chapters-tab__empty">
      <Icon name="general.list" size="base" class="text-zinc-400" />
      <span>No chapters available</span>
    </div>

    <!-- Chapters List -->
    <ul v-else class="chapters-tab__list">
      <li
        v-for="(chapter, index) in chapters"
        :key="index"
        class="chapters-tab__item"
        :class="{ 'chapters-tab__item--active': isActiveChapter(chapter) }"
        data-testid="chapters-tab-item"
      >
        <button type="button" class="chapters-tab__button" @click="seekToChapter(chapter)">
          <span class="chapters-tab__timestamp">
            {{ formatTimeCode(chapter.timecode) }}
          </span>
          <span class="chapters-tab__title">
            {{ chapter.title }}
          </span>
        </button>
        <ButtonClipboard v-bind="getChapterShareConfig(chapter)" class="chapters-tab__share" data-testid="chapters-tab-share" />
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@/storybook';
import ButtonClipboard from './meta_buttons/ButtonClipboard.vue';

import { useChapters } from '../composables/useChapters';

const { hasChapters, chapters, isActiveChapter, formatTimeCode, seekToChapter, getChapterShareConfig } = useChapters();
</script>

<style scoped>
.chapters-tab {
  @apply relative flex flex-col p-4 border border-slate-300 dark:border-zinc-700 bg-white dark:bg-zinc-900 rounded-10;
}

.chapters-tab__empty {
  @apply flex items-center gap-2 text-sm text-zinc-500 dark:text-zinc-400 py-4;
}

.chapters-tab__list {
  @apply flex flex-col gap-1;
}

.chapters-tab__item {
  @apply flex items-center justify-between gap-2 p-2 rounded-lg hover:bg-zinc-100 dark:hover:bg-zinc-700 transition-colors;
}

.chapters-tab__item--active {
  @apply bg-blue-50 dark:bg-blue-900/20 hover:bg-blue-100 dark:hover:bg-blue-900/30;
}

.chapters-tab__item--active .chapters-tab__timestamp {
  @apply text-blue-600 dark:text-blue-400;
}

.chapters-tab__item--active .chapters-tab__title {
  @apply text-blue-700 dark:text-blue-300;
}

.chapters-tab__button {
  @apply flex items-center gap-3 flex-grow text-left min-w-0;
}

.chapters-tab__timestamp {
  @apply flex-shrink-0 text-sm font-mono font-medium text-zinc-500 dark:text-zinc-400 bg-zinc-200 dark:bg-zinc-600 px-2 py-0.5 rounded;
}

.chapters-tab__title {
  @apply text-sm text-zinc-700 dark:text-zinc-300;
}

.chapters-tab__share {
  @apply flex-shrink-0 opacity-0 transition-opacity;
}

.chapters-tab__item:hover .chapters-tab__share {
  @apply opacity-100;
}
</style>
